/** 与 App Header 左右内边距一致，首屏等元素右对齐用 */
export const PAGE_INLINE_PADDING_PX = 50;
